import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
import { PressableField } from "../Pressable";
export const InputBaseContext = /*#__PURE__*/React.createContext({});
class InputBase extends React.Component {
  render() {
    const {
      children,
      className,
      disabled,
      invalid,
      size,
      width
    } = this.props;
    const classes = classNames('InputBase', className);
    const renderableChildren = React.Children.toArray(children); // toArray filters out falsey values
    const items = renderableChildren.map((child, i) => {
      let alignSelfValue = 'flex-start';
      let flexGrowValue = 0;
      let flexShrinkValue = 0;
      // @ts-expect-error - TS2339 - Property 'props' does not exist on type 'ReactChild | ReactFragment | ReactPortal'. | TS2339 - Property 'props' does not exist on type 'ReactChild | ReactFragment | ReactPortal'.
      if (child && child.props && child.props.width === 'maximized') {
        alignSelfValue = 'stretch';
        flexGrowValue = 1;
        flexShrinkValue = 1;
      }
      return /*#__PURE__*/React.createElement(Box, {
        className: "InputBase-item"
        // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'ReactChild | ReactFragment | ReactPortal'.
        ,
        key: child.key,
        flex: true,
        flexBasis: "auto",
        flexGrow: flexGrowValue,
        flexShrink: flexShrinkValue,
        style: {
          alignSelf: alignSelfValue
        }
      }, /*#__PURE__*/React.createElement(InputBaseContext.Provider, {
        value: {
          inputBaseClassName: 'InputBase-pressable',
          disabled,
          invalid,
          ghost: true,
          radius: 'all',
          size
        }
      }, child));
    });
    return /*#__PURE__*/React.createElement(PressableField, {
      className: classes,
      disabled: disabled,
      invalid: invalid,
      size: size,
      width: width
    }, /*#__PURE__*/React.createElement(Box, {
      className: "InputBase-row",
      flex: true
    }, items));
  }
}
InputBase.defaultProps = {
  width: 'auto'
};
export default InputBase;